import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../scss/dashboard.scss';
import Header from '../components/header';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import { DatePicker as AntDatePicker, TimePicker as AntTimePicker } from 'antd';
import moment from 'moment';

const Clocks = () => {
    const [dateTime1, setDateTime1] = useState(new Date());
    const [dateTime2, setDateTime2] = useState(new Date());
    const [dateTime3, setDateTime3] = useState(new Date());
    const [customTime, setCustomTime] = useState('12:00');
    const [antDateTime, setAntDateTime] = useState(moment());
    const [customDate, setCustomDate] = useState(new Date().toISOString().split('T')[0]);

    const handleCustomTimeChange = (e) => {
        setCustomTime(e.target.value);
        const [hours, minutes] = e.target.value.split(':');
        const newDate = new Date(customDate);
        newDate.setHours(parseInt(hours, 10));
        newDate.setMinutes(parseInt(minutes, 10));
        // You can use newDate for your logic
    };

    const handleCustomDateChange = (e) => {
        setCustomDate(e.target.value);
        const newDate = new Date(e.target.value);
        const [hours, minutes] = customTime.split(':');
        newDate.setHours(parseInt(hours, 10));
        newDate.setMinutes(parseInt(minutes, 10));
        // You can use newDate for your logic
    };

    // Styles moved to constants for cleaner code
    const pickerContainerStyle = {
        backgroundColor: '#ffffff',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        border: '1px solid #e0e0e0'
    };

    const pickerTitleStyle = { 
        marginTop: '0',
        marginBottom: '15px',
        color: '#333',
        fontSize: '16px',
        fontWeight: '600'
    };

    const inputStyle = { 
        padding: '12px',
        borderRadius: '6px',
        border: '1px solid #ced4da',
        width: '100%',
        fontSize: '14px',
        boxSizing: 'border-box'
    };

    return (
        <div style={{ 
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            minHeight: '100vh',
            backgroundColor: '#f0f2f5',
            marginTop: '50px'
        }}>
            <Header title="Clocks" />
            <div style={{ 
                padding: '20px',
                maxWidth: '1200px',
                margin: '0 auto'
            }}>
                <div style={{ 
                    background: '#ffffff',
                    borderRadius: '10px',
                    marginTop: '20px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    overflow: 'hidden'
                }}>
                    <h3 style={{
                        padding: '20px 20px 0 20px',
                        margin: '0',
                        color: '#444',
                        fontSize: '18px',
                        fontWeight: '600'
                    }}>24-Hour Datetime Pickers</h3>
                    <div style={{ 
                        display: 'grid', 
                        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                        gap: '20px',
                        padding: '20px',
                    }}>
                        {/* React DatePicker */}
                        <div style={pickerContainerStyle}>
                            <h4 style={pickerTitleStyle}>React DatePicker (24h)</h4>
                            <DatePicker
                                selected={dateTime1}
                                onChange={(date) => setDateTime1(date)}
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={15}
                                timeCaption="Time"
                                dateFormat="MMMM d, yyyy HH:mm"
                                style={inputStyle}
                                customInput={<input style={inputStyle} />}
                                timeInputLabel="Time (24h):"
                            />
                        </div>

                        {/* HTML5 Native Input */}
                        <div style={pickerContainerStyle}>
                            <h4 style={pickerTitleStyle}>HTML5 Native</h4>
                            <input
                                type="datetime-local"
                                value={dateTime2.toISOString().slice(0, 16)}
                                onChange={(e) => setDateTime2(new Date(e.target.value))}
                                style={inputStyle}
                                placeholder="YYYY-MM-DD HH:MM"
                            />
                        </div>

                        {/* Custom Time Input with 24h Format */}
                        <div style={pickerContainerStyle}>
                            <h4 style={pickerTitleStyle}>Custom Time Input (24h)</h4>
                            <input
                                type="time"
                                value={dateTime3.toTimeString().slice(0, 5)}
                                onChange={(e) => {
                                    const [hours, minutes] = e.target.value.split(':');
                                    const newDate = new Date(dateTime3);
                                    newDate.setHours(parseInt(hours, 10));
                                    newDate.setMinutes(parseInt(minutes, 10));
                                    setDateTime3(newDate);
                                }}
                                step="300" // 5 min increments
                                style={inputStyle}
                                pattern="[0-9]{2}:[0-9]{2}"
                            />
                        </div>

                        {/* Custom Split Date/Time Picker */}
                        <div style={pickerContainerStyle}>
                            <h4 style={pickerTitleStyle}>Custom Split Date & Time</h4>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <input
                                    type="date"
                                    value={customDate}
                                    onChange={handleCustomDateChange}
                                    style={inputStyle}
                                />
                                <input
                                    type="time"
                                    value={customTime}
                                    onChange={handleCustomTimeChange}
                                    step="300" // 5 min increments
                                    style={inputStyle}
                                />
                            </div>
                        </div>

                        {/* Custom Ant Design DateTimePicker */}
                        <div style={pickerContainerStyle}>
                            <h4 style={pickerTitleStyle}>Custom Ant Design DateTimePicker</h4>
                            <div style={{ display: 'flex', gap: '10px' }}>
                            <AntDatePicker
                                value={antDateTime}
                                onChange={(date) => setAntDateTime(date)}
                                style={{ ...inputStyle, flex: 1 }}
                                getPopupContainer={trigger => trigger.parentNode}
                            />
                            <AntTimePicker
                                value={antDateTime}
                                onChange={(time) => setAntDateTime(time)}
                                format="HH:mm"
                                style={{ ...inputStyle, flex: 1 }}
                                getPopupContainer={trigger => trigger.parentNode}
                                use12Hours={false}
                            />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Clocks;